export default "__VITE_ASSET__CxBNEb$E__"